(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  var api = window.SwishSystemIntake;
  if (!api || typeof api.postThemePayload !== 'function' || api.postThemePayload.automailedAdapterVersion === 1) return;
  var legacyPost = api.postThemePayload;
  var ensureIntakeId = api.ensureIntakeIdField;
  var adapterScript = document.currentScript;
  var records = new Map();
  var retainedBytes = 0;
  var MAX_BODY_BYTES = 512 * 1024;
  var MAX_RESPONSE_BYTES = 32 * 1024;
  var MAX_RECORDS = 32;
  var MAX_RETAINED_BYTES = 4 * 1024 * 1024;
  var REQUEST_TIMEOUT_MS = 60 * 1000;
  var ID_PATTERN = /^[A-Za-z0-9_-]{8,100}$/;
  var encoder = typeof window.TextEncoder === 'function' ? new window.TextEncoder() : null;

  function failure(reason, message, result) {
    var value = { ok: false, skipped: true, reason: reason, error: message };
    if (result !== undefined) value.result = result;
    return value;
  }
  function configuredEndpoint(section) {
    var local = section && typeof section.getAttribute === 'function' ? section.getAttribute('data-automailed-intake-endpoint') : '';
    var script = adapterScript && adapterScript.getAttribute('data-automailed-intake-endpoint');
    var candidates = [local, script, window.AUTOMAILED_INTAKE_ENDPOINT], text = '';
    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];
      if (candidate === null || candidate === undefined || candidate === '') continue;
      if (typeof candidate !== 'string') return { invalid: true };
      if (candidate.trim()) { text = candidate.trim(); break; }
    }
    if (!text) return { absent: true };
    try {
      var url = new URL(text);
      var token = url.pathname.slice('/api/public/contact/'.length);
      if (text.length > 2500 || url.protocol !== 'https:' || url.username || url.password || url.port || url.search || url.hash ||
        !/^\/api\/public\/contact\/ef1\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]{43}$/.test(url.pathname) || token.length > 2000) return { invalid: true };
      return { url: url.href };
    } catch (_) { return { invalid: true }; }
  }

  // Swish-only captured display fields; no pricing/source/send authority.
  var enrichCapturedSwishFields = (function () {
      function hasFiniteNumber(value) {
          return typeof value === "number" && Number.isFinite(value);
      }
      function roundDisplayDimension(value) {
          const fixed = Math.abs(value) >= 100 ? value.toFixed(0) : value.toFixed(2);
          return fixed.replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
      }
      function toDisplayUnitSuffix(unit) {
          return unit === "FOOT" ? "ft" : "m";
      }
      function formatDimensionValue(value, unit) {
          if (!hasFiniteNumber(value) || !unit)
              return "";
          return `${roundDisplayDimension(value)} ${toDisplayUnitSuffix(unit)}`;
      }
      function formatDimensionPair(input) {
          if (!hasFiniteNumber(input.width) || !hasFiniteNumber(input.length) || !input.unit)
              return "";
          return `${roundDisplayDimension(input.width)} x ${roundDisplayDimension(input.length)} ${toDisplayUnitSuffix(input.unit)}`;
      }
      const SPORT_SUBCATEGORY_LABELS = {
          basketball: "Basketball",
          pickleball: "Pickleball",
          padel: "Padel",
          tennis: "Tennis",
          volleyball: "Volleyball",
          rollerblade: "Rollerblade",
          "other-courts": "Other Courts",
          multisport: "Multisport",
          unspecified: "Unspecified",
      };
      const SPORT_SUBCATEGORY_TOKEN_MATCHERS = [
          {
              value: "basketball",
              matches: [
                  /\bbasket\s*ball\b/,
                  /\bbasketball\b/,
                  /\bnba\b/,
                  /\bncaa\b/,
                  /\bfiba\b/,
                  /\bfiba\s*3x3\b/,
                  /\bhs\s*court\b/,
                  /\bhigh\s*school\b/,
                  /\bus\s*high\s*school\b/,
                  /\busahs\b/,
                  /\b2\s*hoop\b/,
                  /\b3\s*hoop\b/,
                  /\b3x3\b/,
              ],
          },
          {
              value: "pickleball",
              matches: [/\bpickle\s*ball\b/, /\bpickleball\b/],
          },
          {
              value: "padel",
              matches: [/\bpadel\b/, /\bpaddleball\b/, /\bpaddle\b/],
          },
          {
              value: "tennis",
              matches: [/\btennis\b/],
          },
          {
              value: "volleyball",
              matches: [/\bvolley\s*ball\b/, /\bvolleyball\b/],
          },
          {
              value: "rollerblade",
              matches: [/\broller\s*blades?\b/, /\brollerblades?\b/],
          },
      ];
      function normalizeToken(value) {
          return String(value !== null && value !== void 0 ? value : "")
              .trim()
              .toLowerCase()
              .replace(/[_-]+/g, " ")
              .replace(/\s+/g, " ");
      }
      function resolveTokenSportSubcategory(value) {
          const normalized = normalizeToken(value);
          if (!normalized) {
              return null;
          }
          for (const matcher of SPORT_SUBCATEGORY_TOKEN_MATCHERS) {
              if (matcher.matches.some((pattern) => pattern.test(normalized))) {
                  return matcher.value;
              }
          }
          return "other-courts";
      }
      function getSportSubcategoryLabel(value) {
          return SPORT_SUBCATEGORY_LABELS[value];
      }
      function resolveSportSubcategory(input) {
          var _a, _b;
          const resolvedValues = new Set();
          for (const token of (_a = input.sports) !== null && _a !== void 0 ? _a : []) {
              const resolved = resolveTokenSportSubcategory(token);
              if (resolved) {
                  resolvedValues.add(resolved);
              }
          }
          const resolvedCourtType = resolveTokenSportSubcategory(input.courtType);
          if (resolvedCourtType) {
              resolvedValues.add(resolvedCourtType);
          }
          if (!resolvedValues.size) {
              return "unspecified";
          }
          if (resolvedValues.size > 1) {
              return "multisport";
          }
          return (_b = Array.from(resolvedValues)[0]) !== null && _b !== void 0 ? _b : "unspecified";
      }
      function asObject(value) {
          return value && typeof value === "object" && !Array.isArray(value)
              ? value
              : null;
      }
      function getNestedValue(value, path) {
          let current = value;
          for (const key of path) {
              const record = asObject(current);
              if (!record || !(key in record)) {
                  return null;
              }
              current = record[key];
          }
          return current !== null && current !== void 0 ? current : null;
      }
      function getStringValue(value) {
          if (typeof value !== "string")
              return null;
          const trimmed = value.trim();
          return trimmed ? trimmed : null;
      }
      function getNumberValue(value) {
          if (typeof value === "number" && Number.isFinite(value))
              return value;
          if (typeof value === "string") {
              const parsed = Number.parseFloat(value);
              if (Number.isFinite(parsed))
                  return parsed;
          }
          return null;
      }
      function humanizeToken(value) {
          return value
              .replaceAll("_", " ")
              .replaceAll("-", " ")
              .replace(/\s+/g, " ")
              .trim();
      }
      function formatSelectionFlags(value) {
          const selection = asObject(value);
          if (!selection)
              return null;
          const entries = [
              ["L", Boolean(selection.leftOn)],
              ["R", Boolean(selection.rightOn)],
              ["T", Boolean(selection.topOn)],
              ["B", Boolean(selection.bottomOn)],
          ];
          return entries.map(([label, enabled]) => `${label} ${enabled ? "on" : "off"}`).join(" | ");
      }
      function countEnabledSelectionFlags(value) {
          const selection = asObject(value);
          if (!selection)
              return null;
          const count = [selection.leftOn, selection.rightOn, selection.topOn, selection.bottomOn].filter(Boolean).length;
          return count ? `${count}` : "0";
      }
      function formatDirectionalDistances(value, suffix) {
          const record = asObject(value);
          if (!record)
              return null;
          const left = getNumberValue(record.left);
          const right = getNumberValue(record.right);
          const top = getNumberValue(record.top);
          const bottom = getNumberValue(record.bottom);
          if ([left, right, top, bottom].every((entry) => entry == null))
              return null;
          const toPart = (label, amount) => `${label} ${amount == null ? "0" : amount} ${suffix}`;
          return [toPart("L", left), toPart("R", right), toPart("T", top), toPart("B", bottom)].join(" | ");
      }
      function formatCourtColors(lead) {
          var _a, _b, _c;
          const topLevelColors = (_a = asObject(getNestedValue(lead.builderConfiguration, ["colors"]))) !== null && _a !== void 0 ? _a : asObject(getNestedValue(lead.colors, ["colors"]));
          if (topLevelColors) {
              const parts = [
                  ["Main", getStringValue(topLevelColors.main)],
                  ["Key", getStringValue(topLevelColors.key)],
                  ["Lines", getStringValue(topLevelColors.lines)],
                  ["Border", getStringValue(topLevelColors.border)],
                  ["Hoop", getStringValue(topLevelColors.hoopHardware)],
              ].filter(([, value]) => value);
              if (parts.length) {
                  return parts.map(([label, value]) => `${label} ${value}`).join(" | ");
              }
          }
          const flattenedConfig = asObject(lead.builderConfiguration);
          const flattenedParts = [
              ["Main", getStringValue(flattenedConfig === null || flattenedConfig === void 0 ? void 0 : flattenedConfig.main)],
              ["Key", getStringValue(flattenedConfig === null || flattenedConfig === void 0 ? void 0 : flattenedConfig.key)],
              ["Lines", getStringValue(flattenedConfig === null || flattenedConfig === void 0 ? void 0 : flattenedConfig.lines)],
              ["Border", getStringValue(flattenedConfig === null || flattenedConfig === void 0 ? void 0 : flattenedConfig.border)],
          ].filter(([, value]) => value);
          return ((_c = (_b = (flattenedParts.length ? flattenedParts.map(([label, value]) => `${label} ${value}`).join(" | ") : null)) !== null && _b !== void 0 ? _b : getStringValue(getNestedValue(lead.builderConfiguration, ["courtColors"]))) !== null && _c !== void 0 ? _c : getStringValue(getNestedValue(lead.colors, ["summary"])));
      }
      function formatSportName(value) {
          const normalized = value.trim().toLowerCase();
          if (normalized === "paddleball")
              return "padel";
          return normalized;
      }
      function formatSportsList(sports) {
          var _a;
          const normalized = sports.map(formatSportName).filter(Boolean);
          if (normalized.length <= 1)
              return (_a = normalized[0]) !== null && _a !== void 0 ? _a : "";
          if (normalized.length === 2)
              return `${normalized[0]} and ${normalized[1]}`;
          return `${normalized.slice(0, -1).join(", ")}, and ${normalized.at(-1)}`;
      }
      function toMeters(value, units) {
          if (!value)
              return null;
          return units === "ft" ? value / 3.28084 : value;
      }
      var createProjection = function createProjection(h) {
          const obj = value => value && typeof value === 'object' && !Array.isArray(value) ? value : {};
          const text = value => typeof value === 'string' && value.trim() && value.length <= 2000 ? value.trim() : null;
          const positive = value => typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : null;
          const list = value => Array.isArray(value) && value.length <= 30 && value.every(x => typeof x === 'string' && x.length <= 100) ? value.map(x => x.trim().toLowerCase()).filter(Boolean) : null;
          const sides = value => { const o = obj(value); return ['left', 'right', 'top', 'bottom'].every(k => typeof o[k] === 'number' && Number.isFinite(o[k]) && o[k] >= 0) ? o : null; };
          const flags = value => { const o = obj(value); return ['leftOn', 'rightOn', 'topOn', 'bottomOn'].every(k => typeof o[k] === 'boolean') ? o : null; };
          function summaryValue(payload, label) {
              const raw = obj(payload.rawFields), values = [];
              for (const summary of [obj(payload.builder).summary, raw['court summary']]) {
                  if (typeof summary !== 'string')
                      continue;
                  for (const line of summary.split(/\r?\n/u)) {
                      const prefix = '- ' + label + ': ';
                      if (!line.startsWith(prefix))
                          continue;
                      const value = text(line.slice(prefix.length));
                      if (value && value !== '-')
                          values.push(value);
                  }
              }
              const unique = [...new Set(values)];
              return unique.length === 1 ? { value: unique[0], ambiguous: false } : { value: null, ambiguous: unique.length > 1 };
          }
          function derive(payload) {
              var _a, _b, _c, _d, _e, _f, _g;
              const court = obj(payload.court), builder = obj(payload.builder), config = obj((_a = court.builderConfiguration) !== null && _a !== void 0 ? _a : builder.raw), raw = obj(payload.rawFields), additions = {}, preserved = [], holds = [];
              function put(key, value) { if (value === undefined || value === null || value === '')
                  return; if (Object.prototype.hasOwnProperty.call(raw, key)) {
                  if (JSON.stringify(raw[key]) !== JSON.stringify(value))
                      preserved.push(key);
                  return;
              } additions[key] = value; }
              function compound(key, label, provided, fallback) { var _a, _b; const summary = summaryValue(payload, label); if (summary.ambiguous) {
                  holds.push(key);
                  return;
              } put(key, (_b = (_a = summary.value) !== null && _a !== void 0 ? _a : text(provided)) !== null && _b !== void 0 ? _b : fallback()); }
              const w = positive(court.width), l = positive(court.length), unit = court.units === 'm' ? 'METER' : court.units === 'ft' ? 'FOOT' : null;
              put('courtWidth', w);
              put('courtLength', l);
              if (unit) {
                  put('courtWidth_display', h.formatDimensionValue(w, unit));
                  put('courtLength_display', h.formatDimensionValue(l, unit));
                  put('courtSize', h.formatDimensionPair({ width: w, length: l, unit }));
              }
              const nw = unit && w !== null ? h.toMeters(w, court.units) : null, nl = unit && l !== null ? h.toMeters(l, court.units) : null;
              put('normalizedWidth', nw);
              put('normalizedLength', nl);
              put('normalizedWidth_display', h.formatDimensionValue(nw, 'METER'));
              put('normalizedLength_display', h.formatDimensionValue(nl, 'METER'));
              put('normalizedCourtSize', h.formatDimensionPair({ width: nw, length: nl, unit: 'METER' }));
              const sports = list(court.sports), lines = list(court.lines), courtType = (_b = text(court.courtType)) !== null && _b !== void 0 ? _b : text(config.court_type);
              if (sports === null || sports === void 0 ? void 0 : sports.length)
                  put('sports', h.formatSportsList(sports));
              if (lines === null || lines === void 0 ? void 0 : lines.length)
                  put('lines', lines.map(h.humanizeToken).join(', '));
              put('courtType', courtType);
              if ((court.sports === undefined || court.sports === null || sports !== null) && (payload.source === 'BUILDER' || (sports === null || sports === void 0 ? void 0 : sports.length) || courtType)) {
                  const group = h.resolveSportSubcategory({ sports: sports !== null && sports !== void 0 ? sports : [], courtType });
                  put('sportSubcategoryValue', group);
                  put('sportSubcategoryLabel', h.getSportSubcategoryLabel(group));
              }
              const playable = obj(obj(config.config).playableBox);
              compound('playingArea', 'Playable', (_c = config.playable) !== null && _c !== void 0 ? _c : config.playingArea, () => h.formatDimensionPair({ width: positive(playable.width_m), length: positive(playable.length_m), unit: 'METER' }));
              compound('footprint', 'Footprint', config.footprint, () => h.formatDimensionPair({ width: positive(config.widthM), length: positive(config.lengthM), unit: 'METER' }));
              compound('buffers', 'Buffers', config.buffers, () => { const v = sides(obj(config.config).buffers_m); return v ? h.formatDirectionalDistances(v, 'm') : null; });
              compound('hoopOverhang', 'Overhangs', config.overhangs, () => { const v = sides(config.hoopOverhangsM); return v ? h.formatDirectionalDistances(v, 'm') : null; });
              const hoopFlags = flags(config.hoopSelection), borderFlags = flags(config.borderSelection);
              const hoopCount = hoopFlags ? h.countEnabledSelectionFlags(hoopFlags) : null;
              if (hoopCount !== null) {
                  put('hoopCount', Number(hoopCount));
                  put('hoopCount_display', hoopCount);
              }
              put('hoopSelection', hoopFlags ? h.formatSelectionFlags(hoopFlags) : text(config.hoop_selection));
              put('borders', borderFlags ? h.formatSelectionFlags(borderFlags) : text(config.border_boxes));
              put('hoopPreset', (_d = text(config.hoopModelPreset)) !== null && _d !== void 0 ? _d : text(config.hoop_preset));
              const colorInputs = [obj(config.colors), obj(obj(court.colors).colors), config];
              const safeColorFields = ['main', 'key', 'lines', 'border', 'hoopHardware'];
              const colorsSafe = colorInputs.every(o => safeColorFields.every(k => o[k] === undefined || o[k] === null || typeof o[k] === 'string' && o[k].length <= 2000));
              if (colorsSafe)
                  put('courtColors', h.formatCourtColors({ builderConfiguration: config, colors: court.colors }));
              put('previewUrl', (_f = (_e = text(court.previewUrl)) !== null && _e !== void 0 ? _e : text(builder.previewImageUrl)) !== null && _f !== void 0 ? _f : text(obj(payload.attachmentUrls).previewImage));
              put('shareUrl', text(court.shareUrl));
              const dependentFields = { courtWidth: ['courtWidth_display', 'courtSize', 'normalizedWidth', 'normalizedWidth_display', 'normalizedCourtSize'], courtLength: ['courtLength_display', 'courtSize', 'normalizedLength', 'normalizedLength_display', 'normalizedCourtSize'], normalizedWidth: ['normalizedWidth_display', 'normalizedCourtSize'], normalizedLength: ['normalizedLength_display', 'normalizedCourtSize'], hoopCount: ['hoopCount_display'], sports: ['sportSubcategoryValue', 'sportSubcategoryLabel'], courtType: ['sportSubcategoryValue', 'sportSubcategoryLabel'], sportSubcategoryValue: ['sportSubcategoryLabel'], sportSubcategoryLabel: ['sportSubcategoryValue'] };
              for (const conflict of preserved)
                  for (const key of (_g = dependentFields[conflict]) !== null && _g !== void 0 ? _g : []) {
                      if (Object.prototype.hasOwnProperty.call(additions, key)) {
                          delete additions[key];
                          holds.push(key);
                      }
                  }
              // DB official labels and computed Quote records are not captured builder facts.
              // Existing raw officialDimensions/quoteSummary remain untouched; none are invented.
              return { additions, preservedConflictingKeys: [...new Set(preserved)].sort(), heldKeys: [...new Set(holds)].sort() };
          }
          function enrich(payload) { const projection = derive(payload); return { payload: { ...payload, rawFields: { ...obj(payload.rawFields), ...projection.additions } }, projection }; }
          return { derive, enrich };
      };
      var project = createProjection({ formatDimensionValue, formatDimensionPair, toMeters, formatSportsList, humanizeToken, resolveSportSubcategory, getSportSubcategoryLabel, formatDirectionalDistances, countEnabledSelectionFlags, formatSelectionFlags, formatCourtColors });
      return function (payload) {
          if (Object.prototype.hasOwnProperty.call(payload, 'rawFields') && (!payload.rawFields || typeof payload.rawFields !== 'object' || Array.isArray(payload.rawFields))) {
              return { payload: payload, projection: { additions: {}, heldKeys: ['rawFields'], preservedConflictingKeys: [] } };
          }
          var result = project.enrich(payload);
          return Object.keys(result.projection.additions).length ? result : { payload: payload, projection: result.projection };
      };
  })();

  // Validate before serializing, with the same structure/body ceiling as the
  // public source route. Data is never executed, fetched or reinterpreted.
  function snapshot(payload) {
    var nodes = 0, characters = 0;
    function visit(value, depth) {
      if (++nodes > 20000 || depth > 12) throw new Error('structure');
      if (value === null || typeof value === 'boolean') return;
      if (typeof value === 'number' && Number.isFinite(value)) return;
      if (typeof value === 'string') {
        characters += value.length;
        if (value.length > MAX_BODY_BYTES || characters > MAX_BODY_BYTES) throw new Error('characters');
        return;
      }
      if (Array.isArray(value)) {
        if (value.length > 2000) throw new Error('array');
        value.forEach(function (item) { visit(item, depth + 1); });
        return;
      }
      if (value && Object.prototype.toString.call(value) === '[object Object]') {
        var keys = Object.keys(value);
        if (keys.length > 200) throw new Error('keys');
        keys.forEach(function (key) {
          if (!key || key.length > 200 || key.indexOf('\0') !== -1 || ['__proto__', 'prototype', 'constructor'].indexOf(key) !== -1) throw new Error('key');
          visit(value[key], depth + 1);
        });
        return;
      }
      throw new Error('not-json');
    }
    if (!payload || Array.isArray(payload) || Object.prototype.toString.call(payload) !== '[object Object]') throw new Error('payload');
    visit(payload, 0);
    var copy = Object.create(null);
    Object.keys(payload).forEach(function (key) { if (key !== '_installationKey') copy[key] = payload[key]; });
    var bodyText = JSON.stringify(copy);
    if (encoder.encode(bodyText).byteLength > MAX_BODY_BYTES) throw new Error('size');
    // An immutable JSON copy also removes any dependency on caller mutation.
    var body = JSON.parse(bodyText);
    if (typeof body.intakeId !== 'string' || !ID_PATTERN.test(body.intakeId) ||
      body.submissionId !== undefined && body.submissionId !== body.intakeId) throw new Error('id');
    function stable(value, path) {
      if (Array.isArray(value)) return '[' + value.map(function (item) { return stable(item, path.concat('*')); }).join(',') + ']';
      if (value && typeof value === 'object') {
        return '{' + Object.keys(value).sort().filter(function (key) {
          return !(path.length === 0 && key === 'submittedAt') && !(path.length === 1 && path[0] === 'rawFields' && key === 'swish intake id');
        }).map(function (key) { return JSON.stringify(key) + ':' + stable(value[key], path.concat(key)); }).join(',') + '}';
      }
      return JSON.stringify(value);
    }
    return { id: body.intakeId, bodyText: bodyText, meaningfulText: stable(body, []) };
  }
  // Count the exact root-copy JSON bytes from descriptors; never serialize data objects.
  function descriptorJsonBodyBytes(payload, metrics) {
    var nodes = 0, properties = 0, active = new WeakSet();
    function hold(flag) { if (flag) metrics[flag] = true; throw new Error('byte-count-held'); }
    function descriptor(value, key) {
      for (var level = 0, current = value; current !== null; level += 1) {
        if (level >= 32) hold('byteCountCapped');
        var item = Object.getOwnPropertyDescriptor(current, key);
        if (item) return item;
        current = Object.getPrototypeOf(current);
      }
      return null;
    }
    function data(item) {
      if (!item || !Object.prototype.hasOwnProperty.call(item, 'value')) hold('accessor');
      return item.value;
    }
    function textBytes(value) { return encoder.encode(JSON.stringify(value)).byteLength; }
    function count(value, depth, rootCopy) {
      if (++nodes > 20001 || depth > 32) hold('byteCountCapped');
      if (value === null) return 4;
      if (typeof value === 'string') return textBytes(value);
      if (typeof value === 'boolean') return value ? 4 : 5;
      if (typeof value === 'number' && Number.isFinite(value)) return textBytes(value);
      if (!value || typeof value !== 'object') hold('unsupportedType');
      if (active.has(value)) hold('cycle');
      var hook = descriptor(value, 'toJSON');
      if (hook && (!Object.prototype.hasOwnProperty.call(hook, 'value') || typeof hook.value === 'function')) {
        metrics.toJSON = true;
        if (!Object.prototype.hasOwnProperty.call(hook, 'value')) metrics.accessor = true;
        hold();
      }
      var array = Array.isArray(value), bytes = 2, entries = 0;
      if (!array) {
        var prototype = Object.getPrototypeOf(value);
        if (prototype !== null && Object.getPrototypeOf(prototype) !== null) hold('unsupportedType');
      }
      active.add(value);
      try {
        if (array) {
          var length = data(Object.getOwnPropertyDescriptor(value, 'length'));
          if (length > 20001) hold('byteCountCapped');
          for (var index = 0; index < length; index += 1) {
            if (++properties > 20001) hold('byteCountCapped');
            var element = descriptor(value, String(index));
            bytes += (index ? 1 : 0) + (element ? count(data(element), depth + 1, false) : 4);
          }
        } else {
          for (var key in value) {
            if (++properties > 20001) hold('byteCountCapped');
            var own = Object.getOwnPropertyDescriptor(value, key);
            if (!own || !own.enumerable || rootCopy && key === '_installationKey') continue;
            bytes += (entries++ ? 1 : 0) + textBytes(key) + 1 + count(data(own), depth + 1, false);
          }
        }
      } finally { active.delete(value); }
      if (!Number.isSafeInteger(bytes)) hold('byteCountCapped');
      return bytes;
    }
    try {
      if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return null;
      return count(payload, 0, true);
    } catch (_) { return null; }
  }
  // Failure-only, nonauthorizing complexity diagnostics. Never read accessors.
  function boundedFailureMetrics(payload) {
    var result = { observedMaxDepth: 0, visitedNodes: 0, depthLimit: 32, nodeLimit: 20001,
      examinedProperties: 0, propertyLimit: 20001, capped: false, cycle: false,
      accessor: false, unsupportedType: false, totalStringLength: 0, maxStringLength: 0,
      maxArrayLength: 0, maxOwnEnumerableObjectKeys: 0, maxKeyLength: 0 };
    var active = new WeakSet();
    function visit(value, depth) {
      if (depth > result.depthLimit || result.visitedNodes >= result.nodeLimit) { result.capped = true; return; }
      result.visitedNodes += 1;
      result.observedMaxDepth = Math.max(result.observedMaxDepth, depth);
      if (value === null || typeof value === 'boolean') return;
      if (typeof value === 'string') {
        result.totalStringLength += value.length;
        result.maxStringLength = Math.max(result.maxStringLength, value.length);
        return;
      }
      if (typeof value === 'number') { if (!Number.isFinite(value)) result.unsupportedType = true; return; }
      if (typeof value !== 'object') { result.unsupportedType = true; return; }
      if (active.has(value)) { result.cycle = true; return; }
      var array = Array.isArray(value), length = 0, ownObjectKeys = 0;
      try {
        if (array) {
          length = Object.getOwnPropertyDescriptor(value, 'length').value;
          result.maxArrayLength = Math.max(result.maxArrayLength, length);
        }
        else {
          var prototype = Object.getPrototypeOf(value);
          // Recognize ordinary objects across realms without toStringTag getters.
          if (prototype !== null && Object.getPrototypeOf(prototype) !== null) { result.unsupportedType = true; return; }
        }
      } catch (_) { result.unsupportedType = true; return; }
      active.add(value);
      try {
        for (var key in value) {
          if (result.examinedProperties >= result.propertyLimit) { result.capped = true; break; }
          result.examinedProperties += 1;
          var descriptor;
          try { descriptor = Object.getOwnPropertyDescriptor(value, key); }
          catch (_) { result.unsupportedType = true; continue; }
          if (!descriptor || !descriptor.enumerable) continue;
          if (array && (!/^(0|[1-9][0-9]*)$/.test(key) || Number(key) >= length)) continue;
          if (!array) {
            result.maxOwnEnumerableObjectKeys = Math.max(result.maxOwnEnumerableObjectKeys, ++ownObjectKeys);
            result.maxKeyLength = Math.max(result.maxKeyLength, key.length);
          }
          if (!Object.prototype.hasOwnProperty.call(descriptor, 'value')) { result.accessor = true; continue; }
          visit(descriptor.value, depth + 1);
          if (result.visitedNodes >= result.nodeLimit) { result.capped = true; break; }
        }
      } catch (_) { result.unsupportedType = true; }
      finally { active.delete(value); }
    }
    visit(payload, 0);
    result.jsonBodyByteLengthKnown = false;
    result.jsonBodyByteLength = 0;
    result.toJSON = false;
    result.byteCountCapped = false;
    if (!result.capped && !result.cycle && !result.accessor && !result.unsupportedType) {
      var bodyBytes = descriptorJsonBodyBytes(payload, result);
      if (bodyBytes !== null) { result.jsonBodyByteLength = bodyBytes; result.jsonBodyByteLengthKnown = true; }
    }
    return result;
  }
  function matchingField(section, id) {
    if (!section || typeof section.querySelectorAll !== 'function') return null;
    var fields = Array.prototype.slice.call(section.querySelectorAll('[data-swish-intake-id-field]')).filter(function (field) {
      return field.tagName === 'INPUT' && field.type === 'hidden' && field.value === id && field.form;
    });
    return fields.length === 1 ? { field: fields[0], form: fields[0].form } : null;
  }
  function rotateMatchingField(captured, id) {
    if (!captured || typeof ensureIntakeId !== 'function') return;
    var field = captured.field;
    if (!field.isConnected || field.form !== captured.form || field.value !== id) return;
    try {
      field.value = '';
      var next = ensureIntakeId.call(api, captured.form);
      if (typeof next !== 'string' || !ID_PATTERN.test(next) || next === id || field.value !== next) field.value = id;
      else field.defaultValue = next;
    } catch (_) { if (!field.value) field.value = id; }
  }
  async function readResponse(response) {
    if (!response.body || typeof response.body.getReader !== 'function') throw new Error('response-unreadable');
    var reader = response.body.getReader(), chunks = [], size = 0;
    try {
      for (;;) {
        var next = await reader.read();
        if (next.done) break;
        size += next.value.byteLength;
        if (size > MAX_RESPONSE_BYTES) throw new Error('response-size');
        chunks.push(next.value);
      }
    } catch (error) { void reader.cancel().catch(function () {}); throw error; }
    finally { reader.releaseLock(); }
    var all = new Uint8Array(size), position = 0;
    chunks.forEach(function (chunk) { all.set(chunk, position); position += chunk.byteLength; });
    return JSON.parse(new window.TextDecoder('utf-8', { fatal: true }).decode(all));
  }
  function isPositiveAcknowledgement(response, result) {
    return response.ok && result && typeof result === 'object' && !Array.isArray(result) && result.ok === true &&
      result.customerMessagesSent === 0 && result.approvalRequired === true && typeof result.created === 'boolean' &&
      (typeof result.leadId === 'string' && result.leadId.length > 0 || result.leadId === null && result.created === false);
  }
  async function send(record, captured) {
    var controller = new window.AbortController(), timer;
    try {
      var deadline = new Promise(function (_, reject) { timer = window.setTimeout(function () {
        controller.abort(); reject(new Error('deadline'));
      }, REQUEST_TIMEOUT_MS); });
      var operation = (async function () {
        var response = await window.fetch(record.endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', redirect: 'error',
          cache: 'no-store', referrerPolicy: 'no-referrer', headers: { 'Content-Type': 'application/json' }, body: record.bodyText, signal: controller.signal });
        return { response: response, result: await readResponse(response) };
      })();
      var received = await Promise.race([operation, deadline]);
      if (controller.signal.aborted) throw new Error('deadline');
      if (!isPositiveAcknowledgement(received.response, received.result)) {
        return { ok: false, skipped: false, reason: 'automailed-result-unconfirmed', result: received.result,
          error: 'Your inquiry could not be confirmed. Retry with the same details before starting another inquiry.' };
      }
      var result = { ok: true, skipped: false, result: received.result };
      record.resultText = JSON.stringify(result);
      rotateMatchingField(captured, record.id);
      return result;
    } catch (_) {
      return { ok: false, skipped: false, reason: 'automailed-result-unconfirmed',
        error: 'Your inquiry could not be confirmed. Retry with the same details before starting another inquiry.' };
    } finally { window.clearTimeout(timer); }
  }

  function postThemePayload(section, payload) {
    var endpoint = configuredEndpoint(section);
    if (endpoint.absent) return legacyPost.apply(this, arguments);
    if (endpoint.invalid) return Promise.resolve(failure('automailed-endpoint-invalid', 'The configured inquiry endpoint is invalid. Please contact the website owner.'));
    if (!encoder || typeof window.TextDecoder !== 'function' || typeof window.AbortController !== 'function' || typeof window.fetch !== 'function') {
      return Promise.resolve(failure('automailed-browser-unsupported', 'This browser cannot safely submit this inquiry. Please use a current browser.'));
    }
    var value;
    try {
      value = snapshot(payload);
      value = snapshot(enrichCapturedSwishFields(JSON.parse(value.bodyText)).payload);
    }
    catch (error) {
      // Only a closed validation category is logged; never the payload or error.
      var category = 'unknown';
      try {
        var message = error && error.message;
        if (['structure', 'size', 'characters', 'array', 'key', 'not-json', 'id', 'payload'].indexOf(message) !== -1) category = message;
        else if (message === 'keys') category = 'key';
      } catch (_) {}
      try { window.console.warn('[AutoMailed intake] Payload validation rejected: ' + category + '; metrics=' + JSON.stringify(boundedFailureMetrics(payload))); } catch (_) {}
      return Promise.resolve(failure('automailed-payload-invalid', 'Check the inquiry details and size before submitting. No new inquiry was sent.'));
    }
    var record = records.get(value.id), captured = matchingField(section, value.id);
    if (record) {
      if (record.endpoint !== endpoint.url || record.meaningfulText !== value.meaningfulText) {
        return Promise.resolve(failure('automailed-submission-changed', 'This inquiry ID already belongs to different details. Its previous result must be checked before submitting a changed inquiry.'));
      }
      if (record.resultText) { rotateMatchingField(captured, record.id); return Promise.resolve(JSON.parse(record.resultText)); }
      if (record.inFlight) return record.inFlight;
    } else {
      // Never evict an unresolved record or silently recreate its request body.
      var cost = 2 * (value.bodyText.length + value.meaningfulText.length + MAX_RESPONSE_BYTES + 256);
      if (records.size >= MAX_RECORDS || retainedBytes + cost > MAX_RETAINED_BYTES) {
        return Promise.resolve(failure('automailed-capacity-held', 'This page has reached its inquiry retention limit. Check previous inquiry results before opening a new page.'));
      }
      record = { id: value.id, endpoint: endpoint.url, bodyText: value.bodyText, meaningfulText: value.meaningfulText, resultText: null, inFlight: null };
      records.set(value.id, record); retainedBytes += cost;
    }
    record.inFlight = Promise.resolve().then(function () { return send(record, captured); }).finally(function () { record.inFlight = null; });
    return record.inFlight;
  }
  Object.defineProperty(postThemePayload, 'automailedAdapterVersion', { value: 1 });
  api.postThemePayload = postThemePayload;
})();
